import type { ScopeConfig } from './types';
import { BookingScope } from './types';

export const scopeConfigs: ScopeConfig[] = [
  { kpiField: 'requested', label: 'Requested', scope: BookingScope.REQUESTED },
  { kpiField: 'approved', label: 'Approved', scope: BookingScope.APPROVED },
  { kpiField: 'confirmed', label: 'Confirmed', scope: BookingScope.CONFIRMED },
  { kpiField: 'rejected', label: 'Rejected', scope: BookingScope.REJECTED },
  { kpiField: 'drafts', label: 'Drafts', scope: BookingScope.DRAFTS }
];
